import React, { useState } from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import SuccessToast from '../components/SuccessToast';
import ErrorToast from '../components/ErrorToast';
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { confirmEmail, resendCode } from "../services/user-service";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';


const ConfirmCodePage = () => {
    const location = useLocation();
    const [email, setEmail] = useState(location.state?.email || '');
    const [code, setCode] = useState('');
    const [successMessage, setSuccessMessage] = useState(location.state?.message || '');
    const [errorMessage, setErrorMessage] = useState(location.state?.error || '');
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    const [loading, setLoading] = useState(false);

    const handleConfirm = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await confirmEmail(email,code);

            if (response.status === 200) {
                navigate('/setup/subscription', {
                    state: {
                        email: email
                    }
                })
            } else {
                setErrorMessage('Confirmation failed. Please check your code.');
            }
        } catch (err: any) {
            setErrorMessage('Something went wrong. Please try again');
        } finally {
            setLoading(false);
        }
    };

    const handleResendCode = async () => {
        setLoading(true);
        try {
            if(!email) {
                setErrorMessage("Email is required to resend code");
                return;
            }
            const response = await resendCode(email);
            if (response.status === 200) {
                setSuccessMessage('Confirmation code resent!');
            } else {
                setErrorMessage('Unable to resend code. Please try again later');
            }
        } catch (err: any) {
            setErrorMessage('Unable to resend code. Please try again later');
        } finally {
            setLoading(false);
        }
    };

    return (
        isAuthenticated ? <Navigate to="/dashboard" /> :
        <div className="flex flex-col min-h-screen bg-gray-50">
            <NavBar />
            <div className="flex-grow mt-16 ">
                <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded shadow ">
                    <form onSubmit={handleConfirm}
                          className="w-full max-w-md space-y-6 rounded-xl">
                        <h2 className="text-center text-2xl font-semibold text-crumbblue">Confirm Your Account</h2>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">Email</label>
                            <input
                                data-testid='email'
                                type="email"
                                className="mt-1 w-full rounded-md border border-gray-300 p-2 focus:border-crumbblue focus:outline-none"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">Confirmation Code</label>
                            <input
                                data-testid='confirm-code'
                                type="text"
                                className="mt-1 w-full rounded-md border border-gray-300 p-2 focus:border-crumbblue focus:outline-none"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full rounded-md bg-crumbblue p-2 font-semibold text-white hover:bg-opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
                        >
                            Confirm Account
                        </button>


                    </form>
                    <button
                        onClick={handleResendCode}
                        disabled={loading}
                        className="w-full text-crumbblue border border-crumbblue py-2 px-4 rounded hover:bg-blue-50"
                    >
                        Resend Code
                    </button>

                    <SuccessToast data-testid='success-message' message={successMessage} clearSuccess={() => setSuccessMessage('')} />
                    <ErrorToast message={errorMessage} clearError={() => setErrorMessage('')} />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ConfirmCodePage;